// src/utils/email.js
export function emailInitial(email) {
  if (!email) return "?";
  const ch = String(email).trim()[0] || "?";
  return ch.toUpperCase();
}
